import { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useBrand } from "../../../context/BrandContext";
import ReportsList from "../ReportsList";
import { fmtDateTimeWIB, fmtIDR, inp, todayWIB } from "../util";
import { Card, Pill, useLoad } from "./common";

function List({ kind, month, open }) {
    const [items] = useLoad("/reporting/v2/history", { kind, month });
    if (!items) return <div className="text-sm text-neutral-400">Memuat…</div>;
    if (items.length === 0) return <p className="text-sm text-neutral-400" data-testid="history-empty">Belum ada laporan di bulan ini.</p>;
    const target = (x) => (kind === "sales" ? ["sales", { tab: "closing", date: x.reporting_date }] : kind === "finance" ? ["finance", { date: x.reporting_date }] : ["sales", { tab: "pic", date: x.reporting_date, id: x.id }]);
    const value = (x) => (kind === "sales" ? fmtIDR(x.totals?.grand_total_idr) : kind === "finance" ? fmtIDR(x.totals?.total_idr) : `${x.user_name} · ${fmtIDR(x.summary?.closing_total_idr)}`);
    return (
        <ul className="bg-white border border-mist rounded-sm" data-testid={`history-${kind}`}>
            {items.map((x) => (
                <li key={x.id}><button type="button" onClick={() => open(...target(x))} className="w-full text-left px-4 py-3 border-b border-mist/60 flex flex-wrap items-center gap-3 text-sm" data-testid={`history-row-${x.id}`}>
                    <b className="w-24">{x.reporting_date}</b><Pill status={x.status} /><span className="tabular-nums">{value(x)}</span>
                    {kind === "sales" && x.data?.reconciliation_notes?.trim() && <span className="basis-full text-xs text-neutral-600" data-testid={`history-recon-${x.id}`}>Catatan Selisih: {x.data.reconciliation_notes}</span>}
                    <span className="text-[11px] text-neutral-400 ml-auto">{x.first_submitted_at ? `dikirim ${fmtDateTimeWIB(x.first_submitted_at)}` : "draf"} · {x.revisions?.length ?? x.submit_count ?? 0} revisi</span>
                </button></li>
            ))}
        </ul>
    );
}

export default function History({ open, cfg }) {
    const { user } = useAuth();
    const { current } = useBrand();
    const kinds = [...(cfg.can_sales_closing ? [["sales", "Sales Closing"]] : []), ...(["owner", "supervisor", "admin_sales"].includes(user.role) ? [["pic", "Report PIC"]] : []),
        ...(["owner", "finance", "supervisor"].includes(user.role) ? [["finance", "Finance"]] : []), ...(["owner", "admin_sales"].includes(user.role) ? [["legacy", "Laporan lama"]] : [])];
    const [kind, setKind] = useState(kinds[0][0]);
    const [month, setMonth] = useState(todayWIB().slice(0, 7));
    return (
        <div className="space-y-4" data-testid="v2-history">
            <div className="flex flex-wrap gap-2">
                <select value={kind} onChange={(e) => setKind(e.target.value)} className={`${inp} !w-48`} data-testid="history-kind">{kinds.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
                {kind !== "legacy" && <input type="month" value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} className={`${inp} !w-44`} data-testid="history-month" />}
            </div>
            {kind === "legacy" ? <Card title="Laporan harian per admin (sistem lama)"><ReportsList brand={current} refreshKey={0} /></Card> : <List key={kind + month} kind={kind} month={month} open={open} />}
        </div>
    );
}
